import { render, staticRenderFns } from "./PageTopNavigation.vue?vue&type=template&id=29a040a4"
import script from "./PageTopNavigation.vue?vue&type=script&lang=ts"
export * from "./PageTopNavigation.vue?vue&type=script&lang=ts"
import style0 from "./PageTopNavigation.vue?vue&type=style&index=0&id=29a040a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports